import React from 'react';

import { EmptyState } from '../../EmptyState';
import { DataGridErrorConfig } from '../types';
import { DataGridStatePanel } from './DataGridStatePanel';

export interface DataGridErrorStateProps {
  config: DataGridErrorConfig;
}

const DataGridErrorState = ({ config }: DataGridErrorStateProps) => (
  <DataGridStatePanel className="h-[320px] bg-bg-secondary">
    {config.render ? (
      config.render()
    ) : (
      <EmptyState
        heading={config.title}
        description={config.description}
        primaryAction={
          config.action
            ? {
                label: config.action.text,
                onClick: config.action.onClick,
                variant: 'secondary',
              }
            : undefined
        }
        secondaryAction={
          config.secondaryAction
            ? {
                label: config.secondaryAction.text,
                onClick: config.secondaryAction.onClick,
                variant: 'tertiary',
              }
            : undefined
        }
      />
    )}
  </DataGridStatePanel>
);

export { DataGridErrorState };
